import React, { useEffect } from "react";

import { getVSIFileIcon } from "file-extension-icon-js";

import { Avatar, message } from "antd";

import { detalhesArquivo } from "../../services/http/arquivoServico";

import { getIconesExtensao, validarVisualizar } from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";

import IconeArquivos from "../IconeArquivos";

import iconLixeiraListagemSvg from "../../assets/icons/iconLixeiraListagem.svg";
import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import iconDownloadCard from "../../assets/icons/iconDownloadCard.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import iconRecentesNovoSvg from "../../assets/icons/iconRecentesNovo.svg";
import restaurado from "../../assets/icons/restaurado.svg";
import iconLink from "../../assets/icons/iconLink.svg";
import menuCopiarCard from "../../assets/icons/menuCopiarCard.svg";
import iconButtonRestaurar from "../../assets/icons/iconButtonRestaurar.svg";
import iconRecentesAlterado from "../../assets/icons/iconRecentesAlterado.svg";
import iconRecentesAlteradoSvg from "../../assets/icons/iconRecentesAlterado.svg";
import iconVisualizar from "../../assets/icons/olho.svg";
import copiar from "../../assets/icons/copiar.svg";
import favorito from "../../assets/icons/favoritos.png";
import estrela from "../../assets/icons/iconEstrela.svg";

import "./styles.scss";
import { trackPromise } from "react-promise-tracker";
import services from "../../services";
import { verificarDirecionamentoPastaArquivo } from "../../services/http/pastaCompartilhada";

const tabelaColunas = [""];

const ListagemItensRecentes = ({
  setOrdenacao,
  direcionar,
  data,
  mudarPaginaItensRecentes,
  incluirPastaSelecionada,
  showModalVisualizar,
}) => {
  const showIniciais = (nome) => {
    if (!nome) {
      return "";
    }

    let nomecompleto = nome.replace(".", " ");
    var iniciais = nomecompleto.match(/\b(\w)/gi);

    if (iniciais == null) {
      return "";
    }

    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase();
    return sobrenomes;
  };

  const handleAbrirOuVisualizar = (item) => {
    if (item.tipo == 0) {
      incluirPastaSelecionada(item.id, "pasta", item.nomeDocumento);
    } else {
      if (
        validarVisualizar(item.nomeDocumento.split(".")[1]) !== "nao-suportado"
      ) {
        trackPromise(
          detalhesArquivo(item.idArquivo)
            .then((res) => {
              showModalVisualizar(res.data);
            })
            .catch((error) => {
              console.error(error);
            })
        );
      } else {
        message.warning("Extensão não tem suporte a visualização");
      }
    }
  };

  const imagemNovoAlteradoExcluido = (descricao) => {
    if (String(descricao).includes("restaurado")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={restaurado} />
      );
    }
    if (String(descricao).includes("obter link")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={iconLink} />
      );
    }
    if (String(descricao).includes("compartilhar")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={menuCompartilhar}
        />
      );
    }
    if (String(descricao).includes("download")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconDownloadCard}
        />
      );
    }
    if (
      String(descricao).includes("copiar pasta") ||
      String(descricao).includes("copiar arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={menuCopiarCard}
        />
      );
    }
    if (
      String(descricao).includes("mover pasta") ||
      String(descricao).includes("mover arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconButtonRestaurar}
        />
      );
    }
    if (
      String(descricao).includes("editar pasta") ||
      String(descricao).includes("editar permissão") ||
      String(descricao).includes("editar arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlterado}
        />
      );
    }
    if (String(descricao).includes("visualizar")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconVisualizar}
        />
      );
    }
    if (
      String(descricao).includes("renomear pasta") ||
      String(descricao).includes("renomear arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlterado}
        />
      );
    }
    if (
      String(descricao).includes("novo") ||
      String(descricao).includes("nova")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesNovoSvg}
        />
      );
    }

    if (
      String(descricao).includes("alterado") ||
      String(descricao).includes("alterada")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlteradoSvg}
        />
      );
    }

    if (
      String(descricao).includes("excluido") ||
      String(descricao).includes("exclusão de arquivo") ||
      String(descricao).includes("exclusão de pasta")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconLixeiraListagemSvg}
        />
      );
    }
    if (
      String(descricao).includes("copiar pasta") ||
      String(descricao).includes("copiar pasta")
    ) {
      return <img style={{ width: "1.5rem", height: "1.5rem" }} src={copiar} />;
    }
    if (
      String(descricao).includes("favoritar arquivo") ||
      String(descricao).includes("favoritar pasta")
    ) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={favorito} />
      );
    }
    if (String(descricao).includes("editar classificação")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={estrela} />
      );
    }
  };

  const preImagemArquivo = (item) => {
    if (item != null) {
      const extensao = item.extensao ?? item.nomeDocumento.split(".")[1];

      let nomeArquivo =
        !item.nomeDocumento.includes(".") && extensao != null
          ? `${item.nomeDocumento}.${extensao}`
          : item.nomeDocumento;

      if (item.urlPreview) {
        return <img src={item.urlPreview} />;
      } else {
        return <img src={getIconesExtensao(extensao)} />;
      }
    }
  };
  ////////////////////////////////////
  ////////////////////////////////////
  ////////////////////////////////////
  ////////////////////////////////////

  function fnDirecionamento(e) {
    var aux = "";
    if (e.idArquivo) {
      aux = "idArquivo=" + e.idArquivo;
    }
    if (e.idPasta) {
      aux = "idpasta=" + e.idPasta;
    }

    trackPromise(
      verificarDirecionamentoPastaArquivo(aux)
        .then((res) => {
          direcionar(res.data);
        })
        .catch((error) => {
          console.error(error);
        })
    );
  }

  return (
    <>
      <div className="row">
        <table className="table table-borderless col-lg-12 lista-lixeira tabela-recentes p-0">
          <tbody>
            {(!data?.lista || data?.lista.length === 0) && (
              <tr>
                <td colSpan="7">
                  <div className="lixeira-vazia">
                    <img src={iconLixeiraListagemSvg} />
                    <p>A lixeira está vazia</p>
                  </div>
                </td>
              </tr>
            )}
            {data?.lista &&
              data?.lista?.map((item, index) => (
                <tr key={index}>
                  <td style={{ cursor: "default" }}>
                    <div>
                      <div style={{ color: "#0042DD" }}>
                        {item.dataFormatada}
                      </div>
                      {item?.atividadesRecentes?.map((atividade, index) => {
                        return (
                          <>
                            <div key={index} className="container-info-lixeira">
                              <div
                                key={index}
                                className="container-info-icone p-2"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleAbrirOuVisualizar(atividade);
                                }}
                              >
                                {atividade.tipo == 0 ? (
                                  <img src={infoPastaSvg} />
                                ) : (
                                  preImagemArquivo(atividade)
                                )}
                              </div>
                              <div
                                className="container-info-detalhes pr-5"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  fnDirecionamento(atividade);
                                }}
                              >
                                <span>
                                  {imagemNovoAlteradoExcluido(
                                    String(
                                      atividade.descricaoAtividade
                                    ).toLowerCase()
                                  )}
                                  <span style={{ marginLeft: "0.5rem" }}>
                                    {atividade.descricaoAtividade}
                                  </span>
                                </span>
                                <span className="span-avatar">
                                  <Avatar
                                    size={"small"}
                                    style={{
                                      background: "#0042DD",
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    {showIniciais(atividade.autor)}
                                  </Avatar>
                                  <span style={{ marginLeft: "0.5rem" }}>
                                    {atividade.autor}
                                  </span>
                                </span>
                                {
                                  <span className="span-imagem-arquivo-pasta">
                                    {atividade.tipo == 0 ? (
                                      <img
                                        src={infoPastaSvg}
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                        }}
                                      />
                                    ) : (
                                      <IconeArquivos
                                        tamanho={"P"}
                                        tipo={
                                          String(atividade.nomeDocumento).split(
                                            "."
                                          )[1]
                                        }
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                        }}
                                      />
                                    )}
                                    <span style={{ marginLeft: "0.5rem" }}>
                                      {atividade.nomeDocumento}
                                    </span>
                                  </span>
                                }
                              </div>
                            </div>
                            <hr className="divisao-itens-recentes" />
                          </>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div>
        <TablePagination data={data} changePage={mudarPaginaItensRecentes} />
      </div>
    </>
  );
};

export default ListagemItensRecentes;
